import type { StepConfig } from '@features/steps/schema';
import jwConfig from '../../../../public/onboardings/onboarding_japaneseWalking.json';
import jw2Config from '../../../../public/onboardings/onboarding_japaneseWalking2.json';
import shortWallPilatesConfig from '../../../../public/onboardings/onboarding_shortWallPilates.json';
import taiChiConfig from '../../../../public/onboardings/onboarding_taiChi.json';

export const ONBOARDING_FEATURE_NAMES = {
  STATIC: {
    PILATES: 'pilates',
    NEW_BODY: 'newBody',
    CHEAP_OFFER: 'cheapOffer',
    BREAKS: 'breaks',
  },
  API: {
    DEFAULT: 'default',
    WALL_PILATES: 'wallPilates',
    SHORT_WALL_PILATES: 'shortWallPilates',
    TAI_CHI: 'taiChi',
    JAPANESE_WALKING: 'japaneseWalking',
    JAPANESE_WALKING2: 'japaneseWalking2',
  },
} as const;

export type OnboardingFeatureName =
  | (typeof ONBOARDING_FEATURE_NAMES.STATIC)[keyof typeof ONBOARDING_FEATURE_NAMES.STATIC]
  | (typeof ONBOARDING_FEATURE_NAMES.API)[keyof typeof ONBOARDING_FEATURE_NAMES.API];

export const DEFAULT_ONBOARDING_FEATURE = ONBOARDING_FEATURE_NAMES.API.DEFAULT;

export const FEATURES_FOR_GENERATING = [
  // ONBOARDING_FEATURE_NAMES.API.WALL_PILATES,
  ONBOARDING_FEATURE_NAMES.API.SHORT_WALL_PILATES,
  ONBOARDING_FEATURE_NAMES.API.TAI_CHI,
  ONBOARDING_FEATURE_NAMES.API.JAPANESE_WALKING,
  ONBOARDING_FEATURE_NAMES.API.JAPANESE_WALKING2,
  // ONBOARDING_FEATURE_NAMES.STATIC.PILATES,
  // ONBOARDING_FEATURE_NAMES.STATIC.NEW_BODY,
  // ONBOARDING_FEATURE_NAMES.STATIC.CHEAP_OFFER,
  // ONBOARDING_FEATURE_NAMES.STATIC.BREAKS,
  // ONBOARDING_FEATURE_NAMES.API.DEFAULT,
];

export const apiBackedFeatures: OnboardingFeatureName[] = [
  // ONBOARDING_FEATURE_NAMES.API.WALL_PILATES,
  ONBOARDING_FEATURE_NAMES.API.SHORT_WALL_PILATES,
  ONBOARDING_FEATURE_NAMES.API.TAI_CHI,
  ONBOARDING_FEATURE_NAMES.API.JAPANESE_WALKING,
  ONBOARDING_FEATURE_NAMES.API.JAPANESE_WALKING2,
  ONBOARDING_FEATURE_NAMES.API.DEFAULT,
];

export type FunnelConfig = {
  way: string[][];
  fallbackSteps: Record<string, StepConfig>;
  featureFlag: string;
  featureName: OnboardingFeatureName;
};

export const FUNNEL_CONFIGS: Record<string, FunnelConfig> = {
  // [ONBOARDING_FEATURE_NAMES.STATIC.PILATES]: {
  //   way: PILATES_PATH,
  //   // @ts-ignore
  //   fallbackSteps: STEPS,
  //   featureFlag: 'pilatesFeature',
  //   featureName: ONBOARDING_FEATURE_NAMES.STATIC.PILATES,
  // },
  // [ONBOARDING_FEATURE_NAMES.STATIC.NEW_BODY]: {
  //   way: NEW_BODY_PATH,
  //   // @ts-ignore
  //   fallbackSteps: NEW_BODY_STEPS,
  //   featureFlag: 'newBodyFeature',
  //   featureName: ONBOARDING_FEATURE_NAMES.STATIC.NEW_BODY,
  // },
  // [ONBOARDING_FEATURE_NAMES.STATIC.CHEAP_OFFER]: {
  //   way: CHEAP_PATH,
  //   fallbackSteps: CHEAP_STEPS,
  //   featureFlag: 'cheapOfferFeature',
  //   featureName: ONBOARDING_FEATURE_NAMES.STATIC.CHEAP_OFFER,
  // },
  // [ONBOARDING_FEATURE_NAMES.STATIC.BREAKS]: {
  //   way: BREAKS_PATH,
  //   // @ts-ignore
  //   fallbackSteps: BREAKS_STEPS,
  //   featureFlag: 'breaksFeature',
  //   featureName: ONBOARDING_FEATURE_NAMES.STATIC.BREAKS,
  // },
  // [ONBOARDING_FEATURE_NAMES.API.WALL_PILATES]: {
  //   // @ts-ignore
  //   way: shortWallPilatesConfig.way,
  //   // @ts-ignore
  //   fallbackSteps: shortWallPilatesConfig.steps,
  //   featureFlag: 'wallPilatesFeature',
  //   featureName: ONBOARDING_FEATURE_NAMES.API.WALL_PILATES,
  // },
  [ONBOARDING_FEATURE_NAMES.API.SHORT_WALL_PILATES]: {
    // @ts-ignore
    way: shortWallPilatesConfig.way,
    // @ts-ignore
    fallbackSteps: shortWallPilatesConfig.steps,
    featureFlag: 'shortWallPilatesFeature',
    featureName: ONBOARDING_FEATURE_NAMES.API.SHORT_WALL_PILATES,
  },
  [ONBOARDING_FEATURE_NAMES.API.TAI_CHI]: {
    // @ts-ignore
    way: taiChiConfig.way,
    // @ts-ignore
    fallbackSteps: taiChiConfig.steps,
    featureFlag: 'taiChiFeature',
    featureName: ONBOARDING_FEATURE_NAMES.API.TAI_CHI,
  },
  [ONBOARDING_FEATURE_NAMES.API.JAPANESE_WALKING]: {
    // @ts-ignore
    way: jwConfig.way,
    // @ts-ignore
    fallbackSteps: jwConfig.steps,
    featureFlag: 'japaneseWalkingFeature',
    featureName: ONBOARDING_FEATURE_NAMES.API.JAPANESE_WALKING,
  },
  [ONBOARDING_FEATURE_NAMES.API.JAPANESE_WALKING2]: {
    // @ts-ignore
    way: jw2Config.way,
    // @ts-ignore
    fallbackSteps: jw2Config.steps,
    featureFlag: 'japaneseWalking2Feature',
    featureName: ONBOARDING_FEATURE_NAMES.API.JAPANESE_WALKING2,
  },
};
